import { Form } from 'antd';
import { RoleWithDepartment } from 'services/api/department/roleWithDepartment';
import AssignConversationConfigFields, {
  ReceptionConfigProps,
} from '../components/FormFields/AssignConversationConfigFields';

function AssignConversationConfig(
  props: Pick<
    ReceptionConfigProps,
    'departmentId' | 'disabled' | 'roleId' | 'departmentScopes' | 'roleIdAccountsMap'
  >,
) {
  return (
    <Form.Item noStyle dependencies={['permissionWithScopes, rolePermScopeType']}>
      {({ getFieldValue, setFieldsValue }) => {
        const rolePermScopeType: RoleWithDepartment['rolePermScopeType'] =
          getFieldValue('rolePermScopeType');

        const permissionWithScopes: RoleWithDepartment['permissionWithScopes'] =
          getFieldValue('permissionWithScopes') || [];

        const superviserPermission = permissionWithScopes.find(
          (_) => _.permissionName === '管理员视角',
        );

        const onSuperviserPermissionChange = (
          permission?: RoleWithDepartment['permissionWithScopes'][number],
        ) => {
          setFieldsValue({
            permissionWithScopes: [
              ...permissionWithScopes.filter((_) => _.permissionName !== '管理员视角'),
              ...(permission ? [permission] : []),
            ],
          });
        };

        return (
          <AssignConversationConfigFields
            name="assignConversationConfig"
            superviserPermission={superviserPermission}
            onSuperviserPermissionChange={onSuperviserPermissionChange}
            showScopes={rolePermScopeType === 'DIFF_BY_PERM'}
            {...props}
          />
        );
      }}
    </Form.Item>
  );
}

export default AssignConversationConfig;
